import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

// 브라우저 언어 감지 비활성화 - 원복 시 아래 import와 .use(LanguageDetector) 주석 해제, lng 옵션 제거
// import LanguageDetector from 'i18next-browser-languagedetector';
import de from './de/translation.json';
import en from './en/translation.json';
import ko from './ko/translation.json';

i18next
  .use(initReactI18next)
  // .use(LanguageDetector)
  .init({
    lng: 'ko', // 브라우저 언어 미사용, 로그인 후 계정 언어(langCd)로 전환
    resources: {
      en: {
        translation: en,
      },
      ko: {
        translation: ko,
      },
      de: {
        translation: de,
      },
    },
    fallbackLng: 'ko', // 지원하지 않는 언어일 때 사용할 기본 언어
    debug: process.env.NODE_ENV === 'development', // 개발 환경에서만 로그 출력
    interpolation: {
      escapeValue: false, // escape 방지("/" 등 특수문자)
    },
  });
